<template>
    <transition name="fade">
      <div v-if="src" class="overlay" @click.prevent="$emit('update:src', false);">
        <a class="overlay-close" @click.prevent="$emit('update:src', false);">✕&nbsp;<span>{{$root.t('menu_close')}}</span></a>
        <div class="wrapper">
          <img
            v-if="srcset"
            :width="width" :height="height" :src="src"
            decoding="async"
            :srcset="`${srcset[1]} 640w, ${srcset[2]} 1280w`"
          />
          <img v-else :width="width" :height="height" :src="src"/>
          <p v-if="caption">
            <span v-if="caption" v-html="caption"/>
          </p>
          <a class="overlay-next" @click.prevent="next" v-if="showNext">&rarr;&nbsp;<span>NEXT</span></a>
        </div>
      </div>
    </transition>
</template>

<script>

export default {
  name: 'Overlay',
  props: [
    'src', 'width', 'height', 'srcset', 'caption', 'showNext'
  ],
  data () {
    return ({})
  },
  mounted () {
  },
  methods: {
    next (e) {
      e.preventDefault()
      e.stopPropagation()
      this.showNext()
      return false
    }
  }
}
</script>

<style lang="scss">

@import '../main';
.overlay {
    position: fixed;
    left: var(--menuwidth-left);
    top: 0px;
    right: var(--menuwidth-right);
    padding: var(--padding);
    bottom: 0px;
    padding-bottom: var(--padding);
    z-index: 200;
    cursor: pointer;
    backdrop-filter: blur(0.125rem);
    background: rgba(var(--paper-color-rgb), 0.75);
    img {
        max-width: 100%;
        @include vh(90, 'max-height');
        display: inline-block;
        width: auto;
        height: auto;
        object-fit: contain;
        object-position: 0 0;
    }
    p {
      @include smallfont;
      max-width: var(--paperwidth);
      width: 100%;
      margin-top: var(--padding-05);
      color: black;
    }
    .wrapper {
      max-height: 100%;
      max-width: 100%;
      position: relative;
    }
    @include sd(){
      .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        position: static;
      }
      @include flex-vertical-center;
      flex-direction: column;
      background: var(--overlay-color);
      z-index: 20000;
      left: 0px;
      top: 0px;
      right: 0px;
      bottom: 0px;
      padding: 0;
      p {
        color: white !important;
        max-width: auto;
        box-sizing: border-box;
        padding: var(--padding);
        width: 100%;
        position: absolute;
        bottom: 0px;
      }
      img {
        max-height: calc(100vh - 3 * var(--menuwidth-hidden))
      }
    }
    @include sm() {
      p {
        padding: var(--padding-05);
      }
    }
    &-next {
      position: absolute;
      @include headerfont;
      display: none;
      height: var(--menuwidth-hidden);
      right: calc(var(--menuwidth-hidden) * 0.5);
      bottom: 0px;
      @include sd() {
        bottom: var(--padding-05);
        right: var(--padding);
      }
      @include sm() {
        bottom: var(--padding-025);
        right: var(--padding-05);
        transform: scale(140%);
        span {
          display: none;
        }
      }
    }
    &-close {
      position: absolute;
      top:0px;
      @include headerfont;
      height: var(--menuwidth-hidden);
      display: none;
      right: calc(var(--menuwidth-hidden) * 0.5);
      @include sd() {
        right: var(--padding);
        @include flex-vertical-center;
        color: white !important;
      }
      @include sm() {
        right: var(--padding-05);
        transform: scale(180%);
        span {
          display: none;
        }
      }
    }
}
.app-tray-active {
  .overlay {
    z-index: 20000;
    background: var(--overlay-color);
    right: var(--menuwidth-hidden);
    left: var(--menuwidth-hidden);
    padding: 0;
    p {
      color: white !important;
      margin-left: var(--menuwidth-hidden);
    }
    img {
      max-width: calc(100vw - 200px);
      @include sd {
        max-width: none;
      }
    }
    &-next,
    &-close {
      color: white !important;
      @include flex-vertical-center;
    }
    @include sd() {
      left: 0px;
      top: 0px;
      right: 0px;
      bottom: 0px;
      p {
        margin-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Overlay.vue